export const sharedReferenceTrackConfig = {
  playbackState: (
    <div>
      <p className={"mb-2"}>
        Toggle between your mix and the ref and try to hear the difference
        between the two. The ref, or reference, is what you want your mix to
        sound like.
      </p>

      <p className={"mb-2"}>
        The grey square indicates which source is being heard.
      </p>

      <p>
        'Auto Toggle' is on by default. It will toggle between the two of these
        at a set interval. You can turn this off.
      </p>
    </div>
  ),
  dailyLivesMeter: (
    <div>
      <p className={"mb-2"}>
        This meter shows you how many lives you have left for the day.
      </p>

      <p>You lose one each time you answer incorrectly. They reset each day.</p>
    </div>
  ),
  submit: (
    <div>
      <p>
        Once you are sure your mix sounds the same as the reference hit submit.
      </p>
    </div>
  ),
};
